"use client";

import type { PortableTextBlock } from "@portabletext/types";

import { RichText } from "@homeinstead/ui/components/RichText";
import { useMemo } from "react";
import { createMediaRichTextComponents } from "../Media";

type ArticleBodyRichTextProps = {
  className?: string;
  value: PortableTextBlock[];
};

/**
 * Article body copy with the app's media renderers attached.
 */
function ArticleBodyRichText({ className, value }: ArticleBodyRichTextProps) {
  const components = useMemo(() => createMediaRichTextComponents(), []);

  return (
    <RichText className={className} components={components} value={value} />
  );
}

export { ArticleBodyRichText };
